export const portableScheduleProps = {
  basename: "/agendamento-movel",
};
